import React, { useState } from 'react';
import './css/Login.css';
import config from '../config';

const ForgotPassword = () => {
  const [email, setEmail] = useState('');
  const [message, setMessage] = useState('');

  const handleResetRequest = (e) => {
    e.preventDefault();

    const user = { email };
    console.log(user)

    fetch(`${config.apiUrl}/forgot-password`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(user)
    })
      .then(response => response.json())
      .then(data => {
        console.log('Response data:', data)
        setMessage('A password reset request was sent to your email.')
      })
      .catch(error => {
        console.error('Error:', error);
        setMessage('Error logging in');
      });

    // Send request to send user an email with a reset link
    // Along with that, store a secure token in the database with a certain expiration
  };

  return (
    <div className="login-container">
      <h2>Password Reset</h2>
      <form onSubmit={handleResetRequest}>
        <div className="form-group">
          <label>Email:</label>
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        <div className="form-group">
          <button onClick={handleResetRequest}>Reset Password</button>
        </div>
      </form>
      {message && <p>{message}</p>}
    </div>
  );
};

export default ForgotPassword;